// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fTxNsA2jV4X7in {
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  background-color: var(--tr-background-list);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fTxNsA2jV4X7in`
};
export default ___CSS_LOADER_EXPORT___;
